import {makeAutoObservable} from "mobx";
import {makePersistable} from "mobx-persist-store";

class UserStore {
    user = {
        username: {
            value: ''
        }, 
        password: {
            value: ''
        }
    }

    tokens = {
        access: '',
        refresh: '',
    }

    authError = false;
    isUserNotAuth = false;

    setAuthError(value) {
        this.authError = value;
    }

    setIsUserNotAuth(value) {
        this.isUserNotAuth = value;
    }

    constructor(){
        makeAutoObservable(this);
        makePersistable(this,
            {
                name: 'UserStore',
                properties: [
                    'user', 'tokens'
                ],
                storage: window.localStorage
             })
    }
}

const userStore = new UserStore();
export default userStore;